<script>
    import { dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip } from './stores.js';
    import * as yup from 'yup'; 
    import { onMount } from "svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import AddressComponent from './components/addresscomponent.svelte';
    

    onMount(async() => {

    });

    let address_element;
    let city_element;
    let zipcode_element;
    let state_element;
    let user_address;

    function doSelectAddress(){
        console.log(user_address);
        zipcode_element.value = user_address.zipcode;
        city_element.value = user_address.city;
        state_element.value = user_address.state;
        // address_element.value = user_address.address;
        // $user_data.currentaddress = user_address.address;
        // setTimeout(() => {
            // $user_data['currentaddress'] = user_address.address;
        // }, 100);
    }


    const formSchema = yup.object().shape({
        // address_element: yup
        // .string()
        // .required('Address required to find the best rates.'),
        city_element: yup
        .string()
        .required('City or town required to find the best rates.'),
        zipcode_element: yup
        .string()
        .required('Zip code required to find the best rates.'),
        state_element: yup
        .string()
        .required('State required to find the best rates.'),
    });
    async function checkNext() {
        clearAllInvalidItems();
        let res = false;
        await formSchema.validate({ 
            // address_element: address_element.value.trim(),
            city_element: city_element.value.trim(),
            zipcode_element: zipcode_element.value.trim(),
            state_element: state_element.value.trim(),
        }).then(function (value) {
            res = true;
        }).catch(function (err) {
                invalidateItem(eval(err.path), err.errors[0]);
            res = false;
        });

        return res;
    }

    function clearFunction() {
        dbClearAllInvalidItems();
    }

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    pre_next_callback_function={checkNext}
    title="Great! What's your new property address?"
    >
    <div class="formcontainer">
        <div class="formrow">
            <div class="formrowlabel">Address</div>
            <div class="formrowinput">
            <!-- <input on:keyup={()=>{clearFunction();}} bind:this={address_element} bind:value={$user_data.propertyaddress} type="text" /> -->
                                        <AddressComponent
                            ariaLabel=" "
                            placeholder=" "
                            bind:value={user_address}
                            bind:this={address_element}
                            on:placeChanged={()=>{doSelectAddress();}}
                            styleClass="addresscomponent"
                            apiKey="AIzaSyDJ8ajGxShBN-_cmSsdw-QhNAgN0z1JRaA"/>

            </div>
        </div>
        <div class="multipleformrow">
            <div class="formrow">
                <div class="formrowlabel">Apt/Unit</div>
                <div class="formrowinput"><input bind:value={$user_data.propertyaptunit} type="text" /></div>
            </div>
            <div class="formrow">
                <div class="formrowlabel">City or Town</div>
                <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={city_element} bind:value={$user_data.propertycity} type="text" /></div>
            </div>
        </div>
        <div class="multipleformrow">
            <div class="formrow">
                <div class="formrowlabel">Zip code</div>
                <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={zipcode_element} bind:value={$user_data.propertyzipcode} type="text" /></div>
            </div>
            <div class="formrow">
                <div class="formrowlabel">State</div>
                <div class="formrowinput"><select  on:change={()=>{clearFunction();}} bind:this={state_element} bind:value={$user_data.propertystate}><option value="AL">Alabama</option><option value="AK">Alaska </option><option value="AZ">Arizona</option><option value="AR">Arkansas   </option><option value="CA">California </option><option value="CO">Colorado   </option><option value="CT">Connecticut</option><option value="DE">Delaware   </option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii </option><option value="ID">Idaho  </option><option value="IL">Illinois   </option><option value="IN">Indiana</option><option value="IA">Iowa   </option><option value="KS">Kansas </option><option value="KY">Kentucky   </option><option value="LA">Louisiana  </option><option value="ME">Maine  </option><option value="MD">Maryland   </option><option value="MA">Massachusetts  </option><option value="MI">Michigan   </option><option value="MN">Minnesota  </option><option value="MS">Mississippi</option><option value="MO">Missouri   </option><option value="MT">Montana</option><option value="NE">Nebraska   </option><option value="NV">Nevada </option><option value="NH">New Hampshire  </option><option value="NJ">New Jersey </option><option value="NM">New Mexico </option><option value="NY">New York   </option><option value="NC">North Carolina </option><option value="ND">North Dakota   </option><option value="OH">Ohio   </option><option value="OK">Oklahoma   </option><option value="OR">Oregon </option><option value="PA">Pennsylvania   </option><option value="RI">Rhode Island   </option><option value="SC">South Carolina </option><option value="SD">South Dakota   </option><option value="TN">Tennessee  </option><option value="TX">Texas  </option><option value="UT">Utah   </option><option value="VT">Vermont</option><option value="VA">Virginia   </option><option value="WA">Washington </option><option value="WV">West Virginia  </option><option value="WI">Wisconsin  </option><option value="WY">Wyoming</option></select></div>
            </div>
        </div>

    </div>
    </Progresscomponent>
</Dtemplate>

<style>
.formcontainer {
    margin-top: 40px;
    width: 100%;
    max-width: 550px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
input, select {
    outline: none;
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box;
    /* height: 100%; */
    padding: 10px;
    border: 1px solid;
    border-color: var(--blueslate);
    -webkit-appearance: none; 
    -moz-appearance: none; 
}
select {
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 5px;
}
.copycontainer {
    color: var(--blueslate);
    width: 100%;
    font-size: 1em;
    line-height: 1.5em;
}
.sectionheader {
    width: 100%;
    font-size: 1.5em;
    font-weight: 400;
    padding-top: 20px;
    padding-bottom: 20px
}
.formrow {
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}
.formrowlabel {
    color: var(--blueslate);
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 1em;
    text-align: left;;
}
.formrowinput {
    height: 100%;
    max-height: 47px;  
    box-sizing: border-box;  
}
.formrowinput input,.formrowinput select {
    height: 100%;
}
.multipleformrow {
    width: 100%;
    padding: 0px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 15px;
    box-sizing: border-box;
  }
</style>